import isArray from 'lodash/isArray'
import { SubmitValues } from 'components/ItemModal/itemModalTypes'
import { CartItemInput, LocationItemStatus } from 'global-graphql-types'

import { ItemQuestionsFragment } from './types/ItemQuestionsFragment'

type LocationItemQuestionsType =
  ItemQuestionsFragment['locationItemQuestions'][number]

export default function getCartItemInput({
  questions,
  values,
  id,
  omitInstruction = false
}: {
  questions: LocationItemQuestionsType[]
  values: SubmitValues
  id: number
  omitInstruction?: boolean
}): CartItemInput {
  const activeQuestions = questions.filter(
    (q: LocationItemQuestionsType) => q.status === LocationItemStatus.Active
  )
  const questionsInput = activeQuestions.map((q) => {
    const key = `question-${q.id}`
    const formAnswer = values[key]
    let answerIds: number[]
    if (isArray(formAnswer)) {
      answerIds = formAnswer
    } else if (formAnswer) {
      answerIds = [formAnswer as number]
    } else {
      answerIds = []
    }
    return {
      id: q.id,
      answerIds
    }
  })
  return {
    locationItemId: id,
    quantity: values.quantity!,
    specialInstructions: omitInstruction ? '' : values.specialInstructions,
    questions: questionsInput
  }
}
